export default __webpack_public_path__ + "svg/logo_light-54d16fc1.svg";